module.exports = __webpack_public_path__ + "static/media/boat.403b7386.png";